<template>
  <div class="h5-container">
    <!-- 顶部导航 -->
    <van-nav-bar
        class="top-bar"
        title="分销返利"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    ></van-nav-bar>

    <!-- 页签切换 -->
    <van-tabs v-model="activeTab" @change="onTabChange">
      <van-tab title="可提交审核" name="pending">
        <div class="tab-content">
          <van-list
              v-model:loading="pendingLoading"
              :finished="pendingFinished"
              finished-text="没有更多了"
              @load="loadPendingData"
          >
            <div v-for="item in pendingList" :key="item.id" class="custom-card">
              <div class="card-header">
                <span class="item-title">球杆编码：{{ item.number }}</span>
                <van-button
                    type="primary"
                    size="small"
                    round
                    class="submit-btn-inline"
                    @click="handleSubmit(item.id)"
                >
                  提交审核
                </van-button>
              </div>
              <div class="card-body">
                <div class="info-row">
                  <span class="label">球杆品牌：</span>
                  <span class="value">{{ item.brand || '-' }}</span>
                </div>
                <div class="info-row">
                  <span class="label">球杆型号：</span>
                  <span class="value">{{ item.model || '-' }}</span>
                </div>
                <div class="info-row">
                  <span class="label">购买人账号：</span>
                  <span class="value">{{ item.account || '-' }}</span>
                </div>
                <div class="info-row">
                  <span class="label">购买人名称：</span>
                  <span class="value">{{ item.nickName || '-' }}</span>
                </div>
              </div>
            </div>
            <div v-if="pendingList.length === 0 && !pendingLoading" class="empty-tip">
              <van-icon name="inbox" size="48" />
              <p>暂无可提交审核的记录</p>
            </div>
          </van-list>
        </div>
      </van-tab>

      <van-tab title="审核中" name="reviewing">
        <div class="tab-content">
          <van-list
              v-model:loading="reviewingLoading"
              :finished="reviewingFinished"
              finished-text="没有更多了"
              @load="loadReviewingData"
          >
            <div v-for="item in reviewingList" :key="item.id" class="custom-card">
              <div class="card-header">
                <span class="item-title">球杆编码：{{ item.number }}</span>
              </div>
              <div class="card-body">
                <div class="info-row">
                  <span class="label">球杆品牌：</span>
                  <span class="value">{{ item.brand || '-' }}</span>
                </div>
                <div class="info-row">
                  <span class="label">球杆型号：</span>
                  <span class="value">{{ item.model || '-' }}</span>
                </div>
                <div class="info-row">
                  <span class="label">购买人账号：</span>
                  <span class="value">{{ item.account || '-' }}</span>
                </div>
                <div class="info-row">
                  <span class="label">购买人名称：</span>
                  <span class="value">{{ item.nickName || '-' }}</span>
                </div>
              </div>
            </div>
            <div v-if="reviewingList.length === 0 && !reviewingLoading" class="empty-tip">
              <van-icon name="hourglass" size="48" />
              <p>暂无审核中的记录</p>
            </div>
          </van-list>
        </div>
      </van-tab>

      <van-tab title="审核完成" name="completed">
        <div class="tab-content">
          <van-list
              v-model:loading="completedLoading"
              :finished="completedFinished"
              finished-text="没有更多了"
              @load="loadCompletedData"
          >
            <div v-for="item in completedList" :key="item.id" class="custom-card">
              <div class="card-header">
                <span class="item-title">球杆编码：{{ item.number }}</span>
              </div>
              <div class="card-body">
                <div class="info-row">
                  <span class="label">球杆品牌：</span>
                  <span class="value">{{ item.brand || '-' }}</span>
                </div>
                <div class="info-row">
                  <span class="label">球杆型号：</span>
                  <span class="value">{{ item.model || '-' }}</span>
                </div>
                <div class="info-row">
                  <span class="label">购买人账号：</span>
                  <span class="value">{{ item.account || '-' }}</span>
                </div>
                <div class="info-row">
                  <span class="label">购买人名称：</span>
                  <span class="value">{{ item.nickName || '-' }}</span>
                </div>
              </div>
            </div>
            <div v-if="completedList.length === 0 && !completedLoading" class="empty-tip">
              <van-icon name="check-circle" size="48" />
              <p>暂无审核完成的记录</p>
            </div>
          </van-list>
        </div>
      </van-tab>
    </van-tabs>

    <!-- 确认弹窗 -->
    <van-dialog
        v-model="showConfirmDialog"
        title="确认提交"
        message="确定要提交分销返利审核吗？"
        :show-cancel-button="true"
        cancel-button-text="取消"
        confirm-button-text="确定"
        @confirm="confirmSubmit"
    />
  </div>
</template>

<script>
import '@/assets/css/mobileGlobal.scss';
import { ref, onMounted } from 'vue';
import { selectSales, salesSubmit } from '@/api/sales';
import { Toast } from "vant";

export default {
  name: 'SaleList',
  setup() {
    // 页签状态
    const activeTab = ref('pending');

    // 加载状态
    const pendingLoading = ref(false);
    const reviewingLoading = ref(false);
    const completedLoading = ref(false);

    // 完成状态
    const pendingFinished = ref(false);
    const reviewingFinished = ref(false);
    const completedFinished = ref(false);

    // 列表数据
    const pendingList = ref([]);
    const reviewingList = ref([]);
    const completedList = ref([]);

    // 页码
    const pendingPage = ref(1);
    const reviewingPage = ref(1);
    const completedPage = ref(1);

    // 确认弹窗
    const showConfirmDialog = ref(false);
    const submitId = ref(null);

    // 通用加载方法（修复核心逻辑）
    const loadData = async (status, list, page, loading, finished) => {

      // 已加载完 / 正在加载 直接拦截
      if (finished.value || loading.value) return;

      loading.value = true;
      try {
        const res = await selectSales({ status, page: page.value });
        if (res.code === 200) {
          const data = res.data || [];
          if (page.value === 1) {
            list.value = data;
          } else {
            list.value.push(...data);
          }
          // 小于10条判定无更多
          finished.value = data.length < 10;
          if (!finished.value) {
            page.value++;
          }
        } else {
          finished.value = true;
        }
      } catch (error) {
        console.error('加载失败：', error);
        finished.value = true;
      } finally {
        loading.value = false;
      }
    };

    // 各标签页加载
    const loadPendingData = () => {
      loadData('0,4', pendingList, pendingPage, pendingLoading, pendingFinished);
    };
    const loadReviewingData = () => {
      loadData('1', reviewingList, reviewingPage, reviewingLoading, reviewingFinished);
    };
    const loadCompletedData = () => {
      loadData('2,3', completedList, completedPage, completedLoading, completedFinished);
    };

    // 页签切换：重置分页，重新加载第一页
    const onTabChange = (name) => {
      activeTab.value = name;

      console.log(111111,activeTab.value);
      if (name === 'pending') {
        pendingPage.value = 1;
        pendingFinished.value = false;
        pendingList.value = [];
        loadPendingData();
      } else if (name === 'reviewing') {
        reviewingPage.value = 1;
        reviewingFinished.value = false;
        reviewingList.value = [];
        loadReviewingData();
      } else {
        completedPage.value = 1;
        completedFinished.value = false;
        completedList.value = [];
        loadCompletedData();
      }
    };

    // 返回
    const onClickLeft = () => {
      window.history.back();
    };

    // 提交审核弹窗
    const handleSubmit = (id) => {
      submitId.value = id;
      showConfirmDialog.value = true;
    };

    // 确认提交
    const confirmSubmit = async () => {
      showConfirmDialog.value = false;
      try {
        const res = await salesSubmit({ id: submitId.value });
        if (res.code === 200) {
          Toast('提交成功');
          // 刷新当前列表
          pendingPage.value = 1;
          pendingFinished.value = false;
          pendingList.value = [];
          loadPendingData();
        } else {
          Toast(res.message || '提交失败');
        }
      } catch (error) {
        Toast('提交失败');
      }
    };

    // 页面挂载 主动加载首个标签页
    onMounted(() => {
      loadPendingData();
    });

    return {
      activeTab,
      pendingLoading,
      reviewingLoading,
      completedLoading,
      pendingFinished,
      reviewingFinished,
      completedFinished,
      pendingList,
      reviewingList,
      completedList,
      showConfirmDialog,
      onClickLeft,
      onTabChange,
      loadPendingData,
      loadReviewingData,
      loadCompletedData,
      handleSubmit,
      confirmSubmit
    };
  }
};
</script>

<style scoped lang="scss">
/* 样式不变，保留原有代码 */
.h5-container {
  min-height: 100vh;
  box-sizing: border-box;
  background-color: #000;
  padding-bottom: 40px;

  @media (min-width: 768px) {
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
    padding-bottom: 60px;
  }
}

::v-deep .van-icon-arrow-left {
  color: #0f0f0f !important;

  @media (min-width: 768px) {
    font-size: 24px;
  }
}

::v-deep .van-nav-bar__text {
  color: #0f0f0f !important;

  @media (min-width: 768px) {
    font-size: 18px;
  }
}

::v-deep .van-nav-bar__title {
  @media (min-width: 768px) {
    font-size: 22px;
    font-weight: bold;
  }
}

.top-bar {
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);

  @media (min-width: 768px) {
    height: 70px;
    line-height: 70px;
  }
}

.tab-content {
  padding: 0 16px;
  margin-bottom: 60px;

  @media (min-width: 768px) {
    padding: 0 20px;
    margin-bottom: 80px;
  }
}

.item-title {
  font-size: 13px;
  font-weight: 500;
  color: #0f0f0f;
  margin-right: 10px;

  @media (min-width: 768px) {
    font-size: 15px;
    font-weight: bold;
  }
}

.status-tag {
  font-size: 10px;
  line-height: 15px;
  padding: 2px 6px;
  margin-left: 10px;
  flex-shrink: 0;
  background: #FFFFFF;
  border: 1px solid;
  border-radius: 15px;

  &.status-pending {
    color: red;
    border-color: red;
  }

  &.status-reviewing {
    color: #1890ff;
    border-color: #1890ff;
  }

  &.status-approved {
    color: green;
    border-color: green;
  }

  &.status-rejected {
    color: red;
    border-color: red;
  }

  @media (min-width: 768px) {
    font-size: 14px;
    line-height: 20px;
    padding: 4px 10px;
    margin-left: 15px;
    border-radius: 20px;
    border-width: 2px;
  }
}

.empty-tip {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  color: #999;

  p {
    margin-top: 10px;
    font-size: 14px;
  }

  @media (min-width: 768px) {
    padding: 80px 0;

    p {
      font-size: 16px;
    }
  }
}

.custom-card {
  margin: 15px;
  border-radius: 12px;
  background: #fff;
  border: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  @media (min-width: 768px) {
    margin: 20px auto;
    border-radius: 16px;
    padding: 20px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    max-width: 100%;
  }
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  border-bottom: 1px solid #f0f0f0;

  @media (min-width: 768px) {
    padding: 16px 20px;
    border-bottom: 1px solid #eee;
  }
}

.card-body {
  padding: 12px 15px;

  @media (min-width: 768px) {
    padding: 16px 20px;
  }
}

.info-row {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-size: 13px;
  width: 100%;

  &:last-child {
    margin-bottom: 0;
  }

  .label {
    color: #0f0f0f;
    width: 80px;
    font-weight: 500;
  }

  .value {
    color: #0f0f0f;
    word-break: break-all;
  }

  @media (min-width: 768px) {
    margin-bottom: 18px;
    font-size: 15px;

    .label {
      width: 100px;
      font-size: 15px;
      font-weight: bold;
    }

    .value {
      font-size: 15px;
      line-height: 1.6;
    }
  }
}
</style>